module.exports = __webpack_public_path__ + "img/adult-green.6d179755.svg";